module.exports = __webpack_public_path__ + "img/member_myPoints_icon_431006.a2c61915.png";